import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosFlagCss = ":host{display:inline-block}img{display:block;height:100%;width:var(--cosmos-flag-width, 100%)}";
const CosmosFlagStyle0 = cosmosFlagCss;

const CosmosFlag$1 = /*@__PURE__*/ proxyCustomElement(class CosmosFlag extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.alt = '';
        this.code = undefined;
        this.loading = 'eager';
    }
    getFlagUrl() {
        if (this.code == 'TW' || this.code == 'TPE') {
            return `https://rbds-static.redbull.com/@cosmos/foundation/latest/flags/cosmos-flag-Worldwide.svg`;
        }
        return `https://rbds-static.redbull.com/@cosmos/foundation/latest/flags/cosmos-flag-${this.code}.svg`;
    }
    render() {
        return (h(Host, { key: 'a06f27720b93078383e38fbba504f196a03884d2' }, h("img", { key: 'd3f8eaded89dcf44fa11a6cea0c8c3afe326ca43', part: "base flag", src: this.getFlagUrl(), loading: this.loading, alt: this.alt })));
    }
    static get style() { return CosmosFlagStyle0; }
}, [1, "cosmos-flag", {
        "alt": [513],
        "code": [513],
        "loading": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-flag"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-flag":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosFlag$1);
            }
            break;
    } });
}

const CosmosFlag = CosmosFlag$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosFlag, defineCustomElement };
